export const URLS = {
  API_URL:
    process.env.REACT_APP_API_URL || "https://api-staging.funcomp.com/api",
  APP_URL: process.env.REACT_APP_APP_URL || "http://localhost:3000/",
};
